<div class="assetDetailsContainer">
  <!-- Asset detail card: -->
  <div
    class="widget flex flex-column p-5 gap-3"
    *appHasPermission="{
      permissions: [permissions.allPermissions.ASSET_DYNAMIC_DATA_READ],
    }"
  >
    @if (timeoutAssetDetails()) {
      <app-timeout></app-timeout>
    } @else if (loadingAssetDetails()) {
      <div class="flex h-full justify-content-center align-items-center">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      @if (currentSelectedAsset) {
        <!-- Top row of asset widget -->
        <div class="flex justify-content-between">
          <span class="greyText">{{
            "gate_administration.asset_types." + getTitle(assetType, false) | translate
          }}</span>
          <div class="flex gap-2">
            @if (currentSelectedAsset.assetType !== allAssetTypes.TENANT) {
              @if (currentSelectedAsset.assetType === allAssetTypes.BUILDING) {
                <app-svg-icon
                  id="editOpeningTimesButton"
                  *appHasPermission="{
                    permissions: [
                      permissions.allPermissions.THIEF_PROTECTION_CONFIG_UPDATE,
                      permissions.allPermissions.THIEF_PROTECTION_CONFIG_CREATE,
                      permissions.allPermissions.THIEF_PROTECTION_CONFIG_READ,
                    ],
                  }"
                  class="pointer"
                  iconName="thief_protection_edit"
                  iconColor="primary"
                  (click)="onEditOpenTimesClick()"
                ></app-svg-icon>
              }
              <app-svg-icon
                id="editAssetButton"
                *appHasPermission="{
                  permissions: [
                    permissions.allPermissions.ASSET_MASTER_DATA_UPDATE,
                    permissions.allPermissions.ASSET_DYNAMIC_DATA_UPDATE,
                  ],
                }"
                class="pointer"
                iconName="edit"
                iconColor="primary"
                (click)="onEditClick(assetType, currentSelectedAsset.id, false)"
              ></app-svg-icon>
            }
            @if (assetType === allAssetTypes.CUSTOMER) {
              <app-svg-icon
                id="usersListButton"
                *appHasPermission="{
                  permissions: [permissions.allPermissions.USER_READ],
                }"
                class="pointer"
                iconName="customer"
                iconColor="primary"
                (click)="onUserListClick()"
              >
              </app-svg-icon>
            }
          </div>
        </div>
        <!-- Content of asset widget: -->
        <div class="flex gap-2 flex-column">
          <div class="flex justify-content-between">
            <span class="greyText font-size-sm"> {{ "gate_administration.asset_details_card.label" | translate }}</span>
            <span>{{ currentSelectedAsset.label }}</span>
          </div>
          @if (isLocation(currentSelectedAsset) || isBuilding(currentSelectedAsset) || isTenant(currentSelectedAsset)) {
            <div class="flex justify-content-between">
              <span class="greyText font-size-sm">
                {{ "gate_administration.asset_details_card.address" | translate }}</span
              >
              @if (
                currentSelectedAsset.address &&
                currentSelectedAsset.address.street &&
                currentSelectedAsset.address.number &&
                currentSelectedAsset.address.zipCode &&
                currentSelectedAsset.address.city
              ) {
                <span>{{
                  currentSelectedAsset.address.street +
                    " " +
                    currentSelectedAsset.address.number +
                    ", " +
                    currentSelectedAsset.address.zipCode +
                    " " +
                    currentSelectedAsset.address.city
                }}</span>
              }
            </div>
          }
          @if (
            isLocation(currentSelectedAsset) ||
            isBuilding(currentSelectedAsset) ||
            isCustomer(currentSelectedAsset) ||
            isTenant(currentSelectedAsset)
          ) {
            <div class="flex justify-content-between">
              <span class="greyText font-size-sm">
                {{ "gate_administration.asset_details_card.email" | translate }}</span
              >
              <span>{{ currentSelectedAsset.email }}</span>
            </div>
          }
          @if (isCustomer(currentSelectedAsset)) {
            <div class="flex justify-content-between">
              <span class="greyText font-size-sm">
                {{ "gate_administration.asset_details_card.phone" | translate }}</span
              >
              <span>{{ currentSelectedAsset.phone }}</span>
            </div>
          }
        </div>
      }
    }
  </div>
  <!-- Widget to show amount of children assets in selected asset -->
  <div
    class="widget countCard flex p-3 justify-content-center gap-3"
    *appHasPermission="{
      permissions: [permissions.allPermissions.ASSET_DYNAMIC_DATA_READ],
    }"
  >
    @if (timeoutAssetDetails()) {
      <app-timeout></app-timeout>
    } @else if (loadingAssetDetails()) {
      <div class="flex h-full justify-content-center align-items-center">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      @if (isTenant(currentSelectedAsset) && currentSelectedAsset.numberOfCustomers !== undefined) {
        <div class="flex justify-content-between align-items-center gap-1 numberOfAssets">
          <app-svg-icon iconName="customer" iconColor="primary" iconSize="l"></app-svg-icon>
          <div class="flex flex-column align-items-center justify-content-center gap-1">
            <span class="value">{{ currentSelectedAsset.numberOfCustomers }}</span>
            <!-- Label for asset amount based on if its more than one -->
            <span class="text-center label">
              {{
                currentSelectedAsset.numberOfCustomers !== undefined && currentSelectedAsset.numberOfCustomers > 1
                  ? ("gate_administration.asset_types.customers" | translate)
                  : ("gate_administration.asset_types.customer" | translate)
              }}</span
            >
          </div>
        </div>
      }
      @if (
        (isTenant(currentSelectedAsset) || isCustomer(currentSelectedAsset)) &&
        currentSelectedAsset.numberOfLocations !== undefined
      ) {
        <div class="flex justify-content-between align-items-center gap-1 numberOfAssets">
          <app-svg-icon iconName="location" iconColor="primary" iconSize="l"></app-svg-icon>
          <div class="flex flex-column align-items-center justify-content-center gap-1">
            <span class="value">{{ currentSelectedAsset.numberOfLocations }}</span>
            <!-- Label for asset amount based on if its more than one -->
            <span class="text-center label">
              {{
                currentSelectedAsset.numberOfLocations !== undefined && currentSelectedAsset.numberOfLocations > 1
                  ? ("gate_administration.asset_types.locations" | translate)
                  : ("gate_administration.asset_types.location" | translate)
              }}</span
            >
          </div>
        </div>
      }
      @if (
        (isTenant(currentSelectedAsset) || isLocation(currentSelectedAsset) || isCustomer(currentSelectedAsset)) &&
        currentSelectedAsset.numberOfBuildings !== undefined
      ) {
        <div class="flex justify-content-between align-items-center gap-1 numberOfAssets">
          <app-svg-icon iconName="building" iconColor="primary" iconSize="l"></app-svg-icon>
          <div class="flex flex-column align-items-center justify-content-center gap-1">
            <span class="value">{{ currentSelectedAsset.numberOfBuildings }}</span>
            <!-- Label for asset amount based on if its more than one -->
            <span class="text-center label">
              {{
                currentSelectedAsset.numberOfBuildings !== undefined && currentSelectedAsset.numberOfBuildings > 1
                  ? ("gate_administration.asset_types.buildings" | translate)
                  : ("gate_administration.asset_types.building" | translate)
              }}</span
            >
          </div>
        </div>
      }
      @if (
        (isTenant(currentSelectedAsset) ||
          isBuilding(currentSelectedAsset) ||
          isLocation(currentSelectedAsset) ||
          isCustomer(currentSelectedAsset)) &&
        currentSelectedAsset.numberOfGateSystems !== undefined
      ) {
        <div class="flex justify-content-between gap-1 align-items-center numberOfAssets">
          <app-svg-icon iconName="gate-0" iconColor="primary" iconSize="l"></app-svg-icon>
          <div class="flex flex-column align-items-center justify-content-center gap-1">
            <span class="value">{{ currentSelectedAsset.numberOfGateSystems }}</span>
            <!-- Label for asset amount based on if its more than one -->
            <span class="text-center label">
              {{
                currentSelectedAsset.numberOfGateSystems !== undefined && currentSelectedAsset.numberOfGateSystems > 1
                  ? ("gate_administration.asset_types.gate_systems" | translate)
                  : ("gate_administration.asset_types.gate_system" | translate)
              }}</span
            >
          </div>
        </div>
      }
    }
  </div>

  <div
    class="assetList widget p-3"
    *appHasPermission="{
      permissions: [permissions.allPermissions.ASSET_DYNAMIC_DATA_READ],
    }"
  >
    @if (timeoutAssetTable()) {
      <app-timeout></app-timeout>
    } @else if (loadingAssetTable()) {
      <div class="flex justify-content-center align-items-center h-full">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      @if (assets) {
        <p-table
          #dt2
          [columns]="selectedCols"
          [value]="assets"
          [tableStyle]="{ 'min-width': '50rem' }"
          [globalFilterFields]="getFilterFields(selectedCols)"
          class="tableHeaderAlignTop fullTable"
          [scrollable]="true"
        >
          <ng-template #caption>
            <div class="flex justify-content-between align-items-end">
              <span>
                @if (tableTitle) {
                  {{ "gate_administration.asset_types." + tableTitle | translate }}
                }
              </span>
              <div class="flex justify-content-end align-items-center gap-2">
                <app-svg-icon
                  id="addAssetButton"
                  *appHasPermission="{
                    permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
                  }"
                  class="pointer"
                  iconName="plus"
                  iconColor="primary"
                  (click)="onCreateClick(getAssetChildrenType(assetType))"
                >
                </app-svg-icon>
                <input
                  pInputText
                  type="text"
                  (input)="filterGlobal(dt2, $event)"
                  [placeholder]="translate.instant('common.search')"
                />
              </div>
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col) {
                @if (col.subField) {
                  <th [pSortableColumn]="col.field + '.' + col.subField">
                    {{ col.header | translate }}<p-sortIcon [field]="col.field + '.' + col.subField" />
                  </th>
                } @else {
                  <th [pSortableColumn]="col.field">{{ col.header | translate }}<p-sortIcon [field]="col.field" /></th>
                }
              }
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                <td>
                  @if (col.subField) {
                    @if (rowData[col.field]) {
                      {{ rowData[col.field][col.subField] }}
                    }
                  } @else {
                    {{ rowData[col.field] | yesNo }}
                  }
                </td>
              }
              <td class="flex gap-4">
                @if (assetType === allAssetTypes.BUILDING) {
                  <app-svg-icon
                    [id]="'duplicateButton' + rowData['id'].toString()"
                    *appHasPermission="{
                      permissions: [
                        permissions.allPermissions.ASSET_MASTER_DATA_CREATE,
                        permissions.allPermissions.ASSET_DYNAMIC_DATA_CREATE,
                      ],
                    }"
                    class="pointer"
                    iconName="duplicate"
                    iconColor="primary"
                    (click)="onDuplicateClick(rowData)"
                  >
                  </app-svg-icon>
                  <app-svg-icon
                    [id]="'componentsListButton' + rowData['id'].toString()"
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.ASSET_COMPONENT_READ],
                    }"
                    class="pointer"
                    iconName="list"
                    iconColor="primary"
                    (click)="onComponentsListClick(rowData)"
                  >
                  </app-svg-icon>
                }

                @if (assetType === allAssetTypes.BUILDING) {
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.HARDWARE_CONFIG_READ],
                    }"
                    [id]="'hardwareConfigurationButton' + rowData['id'].toString()"
                    class="pointer"
                    iconName="cog"
                    iconColor="primary"
                    (click)="onHardwareConfigurationClick(rowData['id'].toString())"
                  />
                }

                @if (assetType === allAssetTypes.LOCATION) {
                  <app-svg-icon
                    [id]="'editOpeningTimesButton' + rowData['id'].toString()"
                    *appHasPermission="{
                      permissions: [
                        permissions.allPermissions.THIEF_PROTECTION_CONFIG_UPDATE,
                        permissions.allPermissions.THIEF_PROTECTION_CONFIG_CREATE,
                        permissions.allPermissions.THIEF_PROTECTION_CONFIG_READ,
                      ],
                    }"
                    class="pointer"
                    iconName="thief_protection_edit"
                    iconColor="primary"
                    (click)="onEditOpenTimesClick(rowData['id'].toString())"
                  ></app-svg-icon>
                }

                <app-svg-icon
                  [id]="'editChildAssetButton' + rowData['id'].toString()"
                  *appHasPermission="{
                    permissions: [
                      permissions.allPermissions.ASSET_MASTER_DATA_UPDATE,
                      permissions.allPermissions.ASSET_DYNAMIC_DATA_UPDATE,
                    ],
                  }"
                  class="pointer"
                  iconName="edit"
                  iconColor="primary"
                  (click)="onEditClick(getAssetChildrenType(assetType), rowData['id'], true)"
                ></app-svg-icon>
                <app-svg-icon
                  [id]="'deleteChildAssetButton' + rowData['id'].toString()"
                  *appHasPermission="{
                    permissions: [permissions.allPermissions.ASSET_MASTER_DATA_DELETE],
                  }"
                  class="pointer"
                  iconName="trash"
                  iconColor="primary"
                  (click)="onDeleteClick($event, rowData['id'], getAssetChildrenType(assetType))"
                ></app-svg-icon>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    }
  </div>
</div>
